var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.4,
    height: 23.455,
    viewBox: "0 0 26.4 23.455",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-warning-940614",
    transform: "translate(-80.79 -73.828)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_651",
    "data-name": "Path 651",
    d: "M143.96,93.8,133.072,74.943a2.23,2.23,0,0,0-3.863,0l-10.967,19a2.23,2.23,0,0,0,1.931,3.345h21.94a2.23,2.23,0,0,0,1.846-3.48ZM129.989,80.668H132.3a.318.318,0,0,1,.319.319l-.637,8.76a.319.319,0,0,1-.319.319h-1.035a.318.318,0,0,1-.319-.319l-.637-8.76a.318.318,0,0,1,.318-.319Zm1.155,13.6a1.553,1.553,0,1,1,1.553-1.553A1.553,1.553,0,0,1,131.144,94.265Z",
    transform: "translate(-37.154 0)",
    fill: "#ff7200"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.312d70a729f10ce13a11423bfb787a73.svg";
export { ForwardRef as ReactComponent };